import {ICustomerCustomQualifiers} from 'coreClasses/customer/ICustomer';
import {CustomerGroup} from 'coreStore/data/customer/types';

import {IBaseFetchOptions, IBaseResponse, IEndpointsMap} from '../ICustomApiConfig';

export const endpointsMap: IEndpointsMap = {
	SET_CONTEXT: {
		path: 'context',
		method: 'PUT'
	}
};

export interface ISetContextOptions extends IBaseFetchOptions {
	body: {
		customQualifiers: ICustomerCustomQualifiers
	};
}

export interface ISetContextResponse extends IBaseResponse {
	customerGroups: Array<CustomerGroup>;
}
